<template>
    <img class="logo" :class="modifier" src="~@/assets/images/logo-davidoff.png" alt="Davidoff Cigarette"
         title="Davidoff Cigarette">
</template>

<script>
    export default {
        props: {
            modifier: String
        }
    }
</script>

<style lang="scss" scoped>

    .logo {
        height: 137px;
        width: auto;
        position: relative;

        &--home {
            margin-top: 235px;
        }

        &--quiz {
            margin-top: 116px;
        }

        &--result {
            margin-top: 116px;
        }

        &--prizes{
            margin-top: 116px;
        }
    }
</style>
